import { api } from '@/lib/axios'
import type { PickupOrderAlertType } from '@/types/order-alerts.types'

const ALERT_STAGE_PRIORITY: Record<PickupOrderAlertType['stage'], number> = {
  confirm_ready: 0,
  confirm_picked_up: 1,
  remind_ready: 2,
  remind_picked_up: 3,
}

function sortOrderAlerts(alerts: PickupOrderAlertType[]) {
  return [...alerts].sort((left, right) => {
    const stageDiff =
      ALERT_STAGE_PRIORITY[left.stage] - ALERT_STAGE_PRIORITY[right.stage]

    if (stageDiff !== 0) return stageDiff

    return Date.parse(left.raisedAt) - Date.parse(right.raisedAt)
  })
}

async function getOrderAlerts(merchantIds: string[]) {
  if (merchantIds.length === 0) return []

  try {
    const { data } = await api.get<PickupOrderAlertType[]>('/orders/alerts', {
      params: {
        merchants: merchantIds.join(','),
      },
    })

    return sortOrderAlerts(data ?? [])
  } catch {
    return []
  }
}

export { getOrderAlerts, sortOrderAlerts }
